"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamDecoder = exports.SprintSettingsDecoder = exports.SprintDurationDecoder = exports.EndMinutesDecoder = exports.EndHoursDecoder = exports.EndDayDecoder = exports.MoveRemainingTasksToDecoder = void 0;
var ts_data_json_1 = require("ts.data.json");
var integer_in_range_1 = require("./integer-in-range");
var organization_1 = require("./organization");
var timestamp_1 = __importDefault(require("./timestamp"));
var timezone_1 = require("./timezone");
exports.MoveRemainingTasksToDecoder = ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('NextSprint'), ts_data_json_1.JsonDecoder.isExactly('Backlog')], 'MoveRemainingTasksTo');
exports.EndDayDecoder = (0, integer_in_range_1.IntegerInRangeDecoder)(0, 6);
exports.EndHoursDecoder = (0, integer_in_range_1.IntegerInRangeDecoder)(0, 23);
exports.EndMinutesDecoder = (0, integer_in_range_1.IntegerInRangeDecoder)(0, 59);
exports.SprintDurationDecoder = ts_data_json_1.JsonDecoder.oneOf([ts_data_json_1.JsonDecoder.isExactly('1 week'), ts_data_json_1.JsonDecoder.isExactly('2 weeks'), ts_data_json_1.JsonDecoder.isExactly('1 hour')], 'SprintDuration');
exports.SprintSettingsDecoder = ts_data_json_1.JsonDecoder.object({
    autoSprints: ts_data_json_1.JsonDecoder.boolean,
    duration: exports.SprintDurationDecoder,
    endDay: exports.EndDayDecoder,
    endHours: exports.EndHoursDecoder,
    endMinutes: exports.EndMinutesDecoder,
    timezone: ts_data_json_1.JsonDecoder.nullable(timezone_1.TimezoneDecoder),
    moveRemainingTasksTo: exports.MoveRemainingTasksToDecoder,
}, 'SprintSettings');
exports.TeamDecoder = ts_data_json_1.JsonDecoder.object({
    name: ts_data_json_1.JsonDecoder.string,
    isPublic: ts_data_json_1.JsonDecoder.boolean,
    currentSprintId: ts_data_json_1.JsonDecoder.nullable(ts_data_json_1.JsonDecoder.string),
    totalSprintsCount: ts_data_json_1.JsonDecoder.number,
    sprintSettings: exports.SprintSettingsDecoder,
    effortUnit: organization_1.effortUnitDecoder,
    createdAt: timestamp_1.default,
    updatedAt: timestamp_1.default,
    deletedAt: ts_data_json_1.JsonDecoder.nullable(timestamp_1.default),
}, 'Team');
